export default __webpack_public_path__ + "static/yieldmo-9f47fa7024d8984d3d04f112669bc1d3.svg";